import React from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import SideMenu from "./SideMenu";
import { LayoutProvider } from "../../context/LayoutContext";
import { ContactsProvider } from "../../context/ContactsContext";
import { useTheme } from "../../hooks/useTheme";

interface IndexProps {
  children: React.ReactNode;
}

const Index = ({ children }: IndexProps) => {

  const { theme, toggleTheme } = useTheme();

  const onChangeLayoutMode = (value: any) => {
    toggleTheme();
  };

  return (
    <LayoutProvider>
      <ContactsProvider>
        <div className="layout-wrapper d-lg-flex">


          {/* Conteúdo */}
          <SideMenu onChangeLayoutMode={onChangeLayoutMode} />
          {children}
          {/* Toast fora do layout para evitar rerender */}
          <ToastContainer autoClose={2000} />
        </div>
      </ContactsProvider>
    </LayoutProvider>
  );
};

export default Index;
